





































































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class MypageSubMenu extends Vue {
  @Prop({ default: [] }) menuData!: any[]
  @Prop({ default: 6 }) count!: number

  visible = false

  mounted() {}

  openModal() {
    this.visible = true
  }

  closeModal() {
    this.visible = false
  }

  selectMenu(index: any, link: any) {
    const item = this.menuData[index]
    if (item.loginRequired && !this.$auth.loggedIn) {
      this.openModal()
      return
    }

    this.$router.push(link)
  }
}
